
<p-toast position="bottom-left">
</p-toast>
<div class="login">
  @if(imagePath){<div class="col-left" [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }"></div>}
  @if(imagePath == undefined){ <div class="col-left">
    <app-swiper-login></app-swiper-login>
  </div>
}
  <div class="col-right">
    <form [formGroup]="resetform" style="height: 100%">
      <div class="login-form">
        <div class="form">
          <div class="form__inner">
            <div class="form__header">
              <div class="login-logo">
                <img src="assets/images/logo.svg">
              </div>

              <h3>Reset Password</h3>
              <p class="small--text">Please enter below your new password.
						  </p>
            </div>

            <fieldset
              class="form__group"
              [ngClass]="{
                'error--field':
                  isPasswordPolicyError || (submitted && f['newPassword'].errors && f['newPassword'].errors['required'])
              }"
            >
              <label class="form__label">NEW PASSWORD</label>
              <div class="single-input-field-wrapper">
                <div class="form__field">
                  <input type="Password" formControlName="newPassword" (keyup)="onPaswordChange($event)" class="form__input"
                         autocomplete="new-form" />
                </div>
                <password-strength-meter class="psm-wrapper" (strengthChange)="onPasswordStrengthChanged($event)"
                                         [password]="f['newPassword'].value!" [enableFeedback]="true" [minPasswordLength] = "passwordPolicy.Length ?? 8" [passwordPolicy]="passwordPolicy" [numberOfProgressBarItems]="policiesCount">
                </password-strength-meter>
               
                @if(submitted){
                <div class="validation validation--error bottom-n15">
                  @if(f['newPassword'].errors && f['newPassword'].errors['required']){
                  <ng-container>
                    {{ 'New password is required.' }}
                  </ng-container>
                }
                  <!-- <ng-container *ngIf="f['newPassword'].errors && f['newPassword'].errors['minlength']">Password must be at least 8 characters
                    long</ng-container> -->
                    @if(!f['newPassword'].errors && passwordPolicy != null && isPasswordPolicyError){
                      <ng-container>
                    {{ passwordPolicyError }}
                  </ng-container>
                }
                </div>
              }
              </div>
            </fieldset>

            <fieldset
              class="form__group"
              [ngClass]="{
                'error--field':
                  submitted &&
                  ((f['confirmPassword'].errors && f['confirmPassword'].errors['required']) ||
                    (f['confirmPassword'].errors && f['confirmPassword'].errors['mustMatch']))
              }"
            >
              <label class="form__label">RETYPE PASSWORD</label>
              <div class="single-input-field-wrapper">
                <div class="form__field">
                  <input type="Password" formControlName="confirmPassword" class="form__input" autocomplete="new-form" />
@if(submitted){
                  <div class="validation validation--error bottom-n15"  >
                    @if(f['confirmPassword'].errors && f['confirmPassword'].errors['required']){ <ng-container>
                      {{ 'Confirm password is required.' }}
                    </ng-container>
                  }
                    @if(f['confirmPassword'].errors && f['confirmPassword'].errors['mustMatch']){  <ng-container>
                      {{ 'Password must Match.' }}
                    </ng-container>
                  }
                  </div>
                }
                </div>
              </div>
            </fieldset>

            <fieldset class="form__group">
              @if(passwordPolicy != null){
              <div>
                <p class="password-hints-title">PASSWORD HINT</p>
                <div class="password-hints">
                  <ul class="">
                    @if(passwordPolicy.IsUpperCase){
                    <li>New Password must have at least one upper case character</li>}
                    @if(passwordPolicy.IsLowerCase){
                    <li>Must have at least one lower case character</li>}
                    @if(passwordPolicy.IsSpecialCharacter){
                    <li>Must have at least one special character</li>}
                    @if(passwordPolicy.IsDigit){
                    <li>Must have at least one digit</li>}
                    @if(passwordPolicy.Length > 0){
                    <li>
                      Password must be minimum {{ passwordPolicy.Length }} characters long
                    </li>
                    }
                    @if(passwordPolicy.LastUsedPassword > 0){
                    <li>
                      Shouldn’t be the last {{ passwordPolicy.LastUsedPassword }} used passwords
                    </li>}
                  </ul>
                </div>
              </div>
            }
            </fieldset>

            <fieldset class="form__group login--actions">
              <div class="auth-button">
                <button class="login-btn" type="button" [disabled]="isSubmit" (click)="resetPassword()">CHANGE</button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
